import urlUtils from '@/utils/urlUtils';

import legacyAppConfig from './appConfig';
import type {AppConfig} from './appConfig.types';
import baseConfig from './baseConfig';
import {getConfig} from './config';
import externalLinksConfig from './externalLinksConfig';
import pushNotificationsConfig from './pushNotificationsConfig';

const getTypedConfig = () => getConfig() as AppConfig;

const getAgeGateSettings = () => getTypedConfig().ageGateSettings || {};
const getIccApiUrl = () => getTypedConfig().iccEndpoint;
const getIccNotificationApiUrl = () => getTypedConfig().iccNotificationApiEndpoint;
const getIccApiHeaderAuthorization = () => getTypedConfig().iccAuthorizationHeader;
const getIccApiHeader_a = () => getTypedConfig().iccApplicationHeader;
const getIccMarketName = () => getTypedConfig().iccMarketHeader;
const getIccAnonymousToken = () => getTypedConfig().iccAnonymousToken;
const getIsIccRefreshTokenEnabled = () => getTypedConfig().isIccRefreshTokenEnabled;
const getIccTermsOfUseLegalPosition = () => getTypedConfig().iccTermsOfUseLegalPosition;
const getIccAttributionNoticeLegalPosition = () => getTypedConfig().iccAttributionNoticeLegalPosition;
const getIccPrivacyNoticeLegalPosition = () => getTypedConfig().iccPrivacyNoticeLegalPosition;
const getEnvironment = () => getTypedConfig().environment;
const getAppVersion = () => process.env.REACT_APP_VERSION || '';
const getAuthLogsUrl = () => getTypedConfig().authLogsUrl;
const getAwsLogLevel = () => getTypedConfig().awsLogLevel;
const getLogLevel = () => getTypedConfig().logLevel;
const getIsDebug = () => getLogLevel() !== 'SILENT';
const getContentPath = () => (process.env.REACT_APP_ENV === 'dev' ? 'https://m.stg.iqos.com/assets/' : '/assets');

const getVapidPublicKey = () => getTypedConfig().vapidPublicKey;
const getFirebaseConfig = () => getTypedConfig().firebaseConfig;
const getLoginSettings = () => getTypedConfig().loginSettings || {};
const getOtpSettings = () => getTypedConfig().otpSettings || {};
const getCountrySettingsList = () => getTypedConfig().countrySettingsList || [];

const getLoginEmailRegex = () => getTypedConfig().loginEmailRegex || '.*';
const getLoginPasswordRegex = () => getTypedConfig().loginPasswordRegex || '.*';
const getRegisterLinkCode = () => getTypedConfig().registerLinkCode;
const getForgotPasswordLinkCode = () => getTypedConfig().forgotPasswordLinkCode;
const getRtlLanguageCodes = () => []; // replace with actual rtl language codes when available

const getStoragePath = () => getTypedConfig().storagePath;

const getAssetsPath = () => {
    const storagePath = getStoragePath();
    const assetsPath = getTypedConfig().assetsPath;

    if (storagePath && assetsPath) {
        return urlUtils.join(storagePath, assetsPath);
    }

    return undefined;
};

const getAmplitudeApiKey = () => getTypedConfig().amplitudeKey;
const isYourDevicesSectionEnabled = () => getTypedConfig().isShopYourDevicesSectionEnabled;
const getOneTrustDomainScriptId = () => getTypedConfig().oneTrustDomainScriptId;
const getGoogleTagManagerId = () => getTypedConfig().googleTagManagerId;
const getSsoLinkDebounceTimeout = () => getTypedConfig().ssoLinkDebounceTimeout;
const getIsSsoCookiesEnabled = () => getTypedConfig().isSsoCookiesEnabled;
const getAutoDeliverySettings = () => getTypedConfig().autoDeliverySettings;
const getCalendarSettings = () => getTypedConfig().calendarSettings;

const appConfig = {
    ...legacyAppConfig,
    ...baseConfig,
    ...externalLinksConfig,
    ...pushNotificationsConfig,
    getAgeGateSettings,
    getAuthLogsUrl,
    getAwsLogLevel,
    getLogLevel,
    getIsDebug,
    getContentPath,
    getFirebaseConfig,
    getVapidPublicKey,
    getCountrySettingsList,
    getLoginSettings,
    getOtpSettings,
    getLoginEmailRegex,
    getLoginPasswordRegex,
    getRegisterLinkCode,
    getForgotPasswordLinkCode,
    getIccApiUrl,
    getIccNotificationApiUrl,
    getIccApiHeaderAuthorization,
    getIccApiHeader_a,
    getIccMarketName,
    getIccAnonymousToken,
    getIsIccRefreshTokenEnabled,
    getIccTermsOfUseLegalPosition,
    getIccAttributionNoticeLegalPosition,
    getIccPrivacyNoticeLegalPosition,
    getEnvironment,
    getAppVersion,
    getStoragePath,
    getAssetsPath,
    getAmplitudeApiKey,
    isYourDevicesSectionEnabled,
    getOneTrustDomainScriptId,
    getGoogleTagManagerId,
    getSsoLinkDebounceTimeout,
    getIsSsoCookiesEnabled,
    getRtlLanguageCodes,
    getAutoDeliverySettings,
    getCalendarSettings,
};

export default appConfig;
